// extracted by mini-css-extract-plugin
module.exports = {"SeamLess":"SeamLess_SeamLess__bERF7","Brands":"SeamLess_Brands__aIeAv"};